<template>
    <main>
        <!-- <section>
            <div class="align-content-center m-5" >
               <h3>Certificate</h3> 
            </div>
            <div class="col-md-6 m-3 page_search">
                <SearchInput v-model="inputValue" />
            </div>
        </section> -->
        <section>
            <div class="align-content-center m-4">
                <div class="page_title" style="display: flex;justify-content: center;">
                    <div class="page_title" style="display: flex;justify-content: center;">
                        <div>
                            <h3 class="page_title" style="display: inline-block;
							height: 4.1rem;
							border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">Certificate </h3>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex; width: 100%;justify-content:right;padding-right: 20px;">
                <SearchInput v-model="inputValue" style="width: 280px;" />
            </div>
        </section>
        <section>
            <div style="width: 100%;margin-top: 6px;">
                <table style="width: 100%;background-color: #1D1D1B;margin: 0 auto;min-height: 100vh;">
                    <tr>
                        <td
                            style="vertical-align: top; padding: 0;background-color: transparent;border-right: 1px solid #424242;width: 1195px;">
                            <section style="background-color: transparent;">
                                <table style="width: 100%;">
                                    <tr style="height: 35px;background-color: #434343;">
                                        <td>
                                            <table style="width: 100%;">
                                                <tr>
                                                    <td style="padding-top: 0px;">
                                                        Code
                                                    </td>
                                                    <td style="width: 120px;padding-top: 0px;">
                                                        CustomerCode
                                                    </td>
                                                    <td style="width: 730px;padding-top: 0px;">
                                                        Name
                                                    </td>
                                                    <td style="width: 80px;padding-top: 0px;">
                                                        Picture
                                                    </td>
                                                    <td style="width: 90px;padding-top: 0px;">
                                                        SaleMan
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>

                                    </tr>
                                    <tr>
                                        <td style="padding-top: 0px;">
                                            <div class="tree-box" style="width: 100%;">

                                                <div class="tree-content" style="overflow: hidden;">
                                                    <el-tree ref="treeleft" :data="treeData" node-key="id" :indent="0"
                                                        class="tree-line" v-if="isRender"
                                                        :default-expanded-keys="expandedKeys"
                                                        :row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px','padding-left':'10px'}"
                                                        :highlight-current="false" :expand-on-click-node="true"
                                                        @node-click="handleNodeClick">
                                                        <!-- <span slot-scope="{ data }" class="custom-tree-node" :style="{ 
                                                            backgroundColor: activeNode && activeNode.id  === data.id  
                                                                ? '#FCB42E' 
                                                                : 'transparent'
                                                            }" style="color: black;"> -->
                                                        <span slot-scope="{ data }" class="custom-tree-node"
                                                            :class="{'nodeClickClass': activeNode && activeNode.id === data.id}">
                                                            <template>
                                                                <div style="display: flex;align-items: center;">
                                                                    <span style="flex:1;text-align: left;width: 140px;">
                                                                        {{ data.code }}
                                                                    </span>
                                                                    <span style="width: 120px;text-align: left;">
                                                                        {{ data.cusPartCode }}
                                                                    </span>
                                                                    <span
                                                                        style="width: 730px;text-align: left;overflow: hidden;">
                                                                        {{ data.name }}
                                                                    </span>

                                                                    <span style="width: 80px;text-align: center;">
                                                                        <div v-if="data.state==2">
                                                                            <a v-if="data.itemNum>0" href="#"
                                                                                @click="showPic(data)"
                                                                                style="color: #4990e2; text-decoration: underline;">
                                                                                {{ data.itemNum }}</a>
                                                                        </div>
                                                                    </span>
                                                                    <span style="width: 90px;text-align: left;">
                                                                        {{ data.saleMan }}
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </span>
                                                    </el-tree>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </section>
                        </td>
                        <!-- <td style="vertical-align: top;padding: 0; padding-left: 1px;">
                            <div
                                style="background-color: transparent;min-height: 100vh;max-width: 893px;border-right: 1px solid #424242;padding: 0;">
                                <table
                                    style=" background-color: #434343;text-align: center; line-height: 1;width: 100%; ">
                                    <thead>
                                        <tr style="height: 35px;">
                                            <td scope="col" style="width: 60px;">
                                                No.
                                            </td>
                                            <td scope="col" style="width: 130px;">
                                                PartsCode
                                            </td>
                                            <td scope="col" style="width: 130px;">
                                                CustomerCode
                                            </td>
                                            <td scope="col" style="width: 420px;">
                                                description
                                            </td>

                                            <td scope="col" style="width: 100px;">
                                                PartType
                                            </td>
                                            <td scope="col" style="width: 60px;">
                                                Picture
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody style="background-color:#1D1D1B;line-height: 20px;">
                                        <tr v-for="(item,index) in data" :key="item.id" class="text-muted highlight"
                                            style="height: 1;color: #606266;padding-top: 10px;padding-bottom: 0;">
                                            <td style="text-align: left;padding-left: 10px;text-align: center;">
                                                {{index+1}}</td>
                                            <td style="text-align: left;padding-left: 10px;">201-0106-001</td>
                                            <td style="text-align: left;padding-left: 10px;">201-0106-001</td>
                                            <td style="text-align: left;padding-left: 30px;">{{item.name}}</td>
                                            <td style="text-align: left;padding-left: 10px;">Work Light</td>
                                            <td>
                                                <a href="#" style="color: #4990e2; text-decoration: underline;">1</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td> -->
                        <td style="vertical-align: top;padding: 0; max-width: 800px;">
                            <div style="background-color: transparent;min-height: 100vh;max-width: 700px;">
                                <table
                                    style=" background-color: #434343;text-align: center; line-height: 1;width: 100%; ">
                                    <thead>
                                        <tr style="height: 35px;">
                                            <td scope="col" style="width: 60px;">
                                                No.
                                            </td>
                                            <td scope="col" style="width: 130px;">
                                                Certificate
                                            </td>
                                            <td scope="col" style="width: 210px;">
                                                description
                                            </td>
                                            <td scope="col" style="width: 60px;">
                                                DownLoad
                                            </td>
                                            <td scope="col" style="width: 120px;">
                                                StartDate
                                            </td>
                                            <td scope="col" style="width: 120px;">
                                                EndDate
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody style="background-color:#1D1D1B;line-height: 1;">
                                        <tr v-for="(item,index) in paginatedData" :key="item.id"
                                            class="text-muted highlight" style="height: 1;color: #606266;">
                                            <td style="text-align: left;padding-left: 10px;text-align: center;">
                                                {{index+1}}</td>
                                            <td style="text-align: left;padding-left: 10px;">{{item.typeName}}</td>
                                            <td style="text-align: left;padding-left: 10px;">{{item.name}}</td>
                                            <td>
                                                <a href="#" style="color: #4990e2; text-decoration: underline;"
                                                    target="_blank"
                                                    @click.prevent="downLoadCert(item.certID,item.itemNum)">{{item.itemNum}}</a>
                                                <!-- <a :href="link" style="color: #4990e2; text-decoration: underline;" @click.prevent="downLoadCert(item)">{{item.itemNum}}</a> -->
                                            </td>
                                            <td style="text-align: left;padding-left: 30px;">{{item.startDate}}</td>
                                            <td style="text-align: left;padding-left: 30px;">{{item.endDate}}</td>

                                        </tr>
                                    </tbody>
                                </table>

                                <div style="height: 30px;"></div>
                                <el-pagination background layout="prev, pager, next" :hide-on-single-page="true"
                                    :total="totalData" :page-size="pageSize" @current-change="handleCurrentChange"
                                    :current-page="currentPage">
                                </el-pagination>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <!-- 弹窗 -->
            <div v-if="dialogVisible" class="popup" style="width: 75%;height: 92%;max-width: 1000px;">

                <div style="height: 30px;text-align: right; background-color: #262626;padding-top: 5px;">
                    <img src="/assets/img/Main/popMin.png" alt="" @click="dialogVisible = false"
                        style="margin-right: 20px;">
                    <img src="/assets/img/Main/popMax.png" alt="" @click="dialogVisible = false"
                        style="margin-right: 20px;">
                    <img src="/assets/img/Main/popExit.png" alt="" @click="dialogVisible = false"
                        style="margin-right: 20px;">

                </div>

                <div style="overflow: auto;max-height: 845px;">

                    <div
                        style="text-align: center;padding-left: 10px;padding-right: 10px; align-items: center;justify-content: center;display: flex; height: 845px;">
                        <img :src="imageSrc" alt="">
                    </div>
                </div>
            </div>
            <el-dialog title="DOWNLOAD" :visible.sync="pdfVisible" width="650px" :before-close="detailClose">
                <el-table :data="downloadList" height="250" border style="width: 100%">
                    <el-table-column prop="name" label="name" width="508">
                    </el-table-column>
                    <el-table-column label="download" width="100">
                        <template slot-scope="scope">
                            <span @click="cellClick(scope.row.name)"
                                style="padding-left: 20px;color: #4990e2; text-decoration: underline;">
                                1
                            </span>
                        </template>
                    </el-table-column>

                </el-table>
            </el-dialog>
        </section>



    </main>
</template>

<script>
    import SearchInput from '@/components/common/SearchInput.vue';
    import { getTreeList, getCertUnionProductList, getCertRight, getPartImg, getCertPdf } from "@/api/rbac/certificate";
    export default {
        components: {
            SearchInput
        },
        data() {
            return {
                inputValue: '',
                treeData: [],
                data: [],
                isRender: true,
                expandedKeys: [],
                activeNode: null,
                dialogVisible: false,
                imageSrc: null,
                downloadList: [],
                pdfVisible: false,
                // 当前页码
                currentPage: 1,
                // 每页显示的数据条数
                pageSize: 20,
                // 总数据条数
                totalData: 0,
            }
        },
        created() {
            this.getTreeList();
        },
        mounted() {

        },
        computed: {
            paginatedData() {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = this.currentPage * this.pageSize;
                return this.data.slice(start, end);
            },
        },
        methods: {
            cellStyle({ rowIndex }) {
                if (rowIndex % 3 === 0) {
                    return { padding: '3 0', border: 0, backgroundColor: '#1D1D1B', color: 'white', 'font-size': '16px' };
                }
                return { padding: '3 0', border: 0, backgroundColor: '#1D1D1B' };
            },
            downLoadCert(id, itemNum) {
                if (itemNum > 0) {
                    //根据ID获取文件地址
                    try {
                        getCertPdf({ id: id }).then(res => {
                            this.downloadList = res.data
                            if (res.data.length == 1) {
                                // const fileUrl = res.data[0].url; // 文件的URL地址
                                const filename = res.data[0].name; // 文件的名

                                // 获取完整的URL
                                // const fullUrl = window.location.href;
                                // 获取协议
                                const protocol = window.location.protocol;
                                // 获取主机名
                                const hostname = window.location.hostname;
                                // 获取端口号
                                const port = window.location.port;
                                const httpUrl = protocol + '//' + hostname + ':' + port + '/assets/img/Certificate/' + filename
                                const a = document.createElement('a');
                                a.href = httpUrl;
                                a.download = filename;
                                a.click();
                                // document.body.removeChild(a)
                                // window.open(httpUrl)
                                // window.open('http://192.168.1.242:8080/assets/img/Certificate/6069_DC1845-Safety%20Static_Image%20projector%20CE-ROHS%20Certificate.pdf')
                            }
                            if (res.data.length > 1) {
                                this.pdfVisible = true;
                            }
                        })
                    } catch (error) {
                        console.error('获取失败:', error);
                    }
                }
            },
            cellClick(name) {
                // 获取协议
                const protocol = window.location.protocol;
                // 获取主机名
                const hostname = window.location.hostname;
                // 获取端口号
                const port = window.location.port;
                const httpUrl = protocol + '//' + hostname + ':' + port + '/assets/img/Certificate/' + name

                const a = document.createElement('a');
                a.href = httpUrl;
                a.download = name;
                a.click();
                // window.open(httpUrl)
            },
            detailClose() {
                this.downloadList = [];
                this.pdfVisible = false;
            },
            getTreeList() {
                getTreeList({ strWhere: '' }).then(res => {
                    this.treeData = res.data;
                    if (res.data.lenght == 0) {
                        this.data = []
                    }
                    else {
                        // this.getDataList('');
                        if (this.treeData.length > 0 && this.treeData[0].children.length > 0) {
                            // this.expandNodes([1])
                        }
                        this.handleNodeClick(this.treeData[0])

                    }
                })
            },
            expandNodes(keys) {
                // this.isRender = false;
                this.$nextTick(() => {
                    this.expandedKeys = keys;
                    this.isRender = true;
                });
            },
            handleNodeClick(node) {
                if (node.pID == 0) {
                    this.expandNodes([1])
                }
                this.getCertRight(node)
                this.activeNode = node;
                this.$refs.treeleft.setCurrentKey(node.id);

                // else if (node.children.length > 0) {
                //     this.getDataList(' and d.pID=' + node.realID);
                // }
                // else {
                //     this.getDataList(' and d.ID=' + node.realID);
                // }
            },
            getDataList(strWhere) {
                getCertUnionProductList({ strWhere: strWhere }).then(res => {
                    this.data = res.data
                })
            },
            getCertRight(node) {
                console.log(node)
                this.currentPage = 1;
                var strWhere = ''
                if (node.state == 1) {
                    strWhere = ' and c.typeID=' + node.realID
                }
                if (node.state == 2) {
                    strWhere = ' and a.partID=' + node.realID
                }
                getCertRight({ strWhere: strWhere }).then(res => {
                    this.data = res.data
                    this.totalData = this.data.length
                })

            },
            showPic(data) {
                this.dialogVisible = true
                getPartImg({ id: data.realID }).then(res => {
                    //                 const url = URL.createObjectURL(new  Blob([res.data.data]));
                    // this.imageSrc  = url;
                    // console.log(url)
                    // const blob=res.blob()
                    this.imageSrc = window.URL.createObjectURL(res.data)
                })
            },
            // 当前页码改变时的处理函数
            handleCurrentChange(page) {
                this.currentPage = page;
            },
        }
    }
</script>

<style scoped>
    .tree-line {
        background-color: transparent;
        color: #D9D9D9;
    }

    /* ::v-deep .el-tree-node.is-current>.el-tree-node__content {
        background: #FCB42E !important;
        color: black;
    } */

    /* :deep(.el-tree-node__content:hover) {
        background-color: #FCB42E !important;
    } */

    .el-table::before {
        background-color: transparent;
    }

    /* :deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
        background-color: #FCB42E !important;
    } */

    .special-cell-class {
        color: white;
    }

    .nodeClickClass {
        background-color: #FCB42E;
        /* color: black; */
    }

    .popup {
        position: fixed;
        top: 53%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #424242;
        /* border: 1px solid #ccc; */
        border-bottom: 10px solid #262626;
        border-left: 10px solid #262626;
        border-right: 10px solid #262626;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        z-index: 1000;
    }
</style>